import PropTypes from 'prop-types';
import { SIZES } from '../base-select/constants';
import { GROUP_OPTION_TYPE, OPTION_TYPE } from '../base-select/types';

export const SIMPLE_SELECT_PROPS = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)])
  ).isRequired,
  defaultValue: PropTypes.shape(OPTION_TYPE),
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  preventOverflow: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.shape(OPTION_TYPE),
  components: PropTypes.shape({
    Option: PropTypes.func,
    SingleValue: PropTypes.func,
    Placeholder: PropTypes.func,
    Input: PropTypes.func,
    ValueContainer: PropTypes.func,
  }),
  maxMenuHeight: PropTypes.number,
  transparent: PropTypes.bool,
  menuWidth: PropTypes.string,
  noVerticalSpacing: PropTypes.bool,
  noHorizontalSpacing: PropTypes.bool,
  noSpacingBetweenElements: PropTypes.bool,
};
